'use strict';

import 'babel/polyfill';
import React from 'react';
import app from '../app';
import createStore from '../app/store';
import Immutable from 'immutable';
import provideContext from '../app/addons/context';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import { Router } from 'react-router';
import { render } from 'react-dom';
import { PropTypes } from 'react';
import { initializeClient } from '../app/actions';

const history = createBrowserHistory();
const debug = require('debug')('svtse:client:debug');
const error = require('debug')('svtse:client:error');
const dehydratedState = window[app.getId()];

history.listen((state) => {
	if(state.action === 'PUSH') {
		window.scrollTo(0, 0);
	}
});
window.Debug = require('debug');
try {
		debug('rehydrating app');
		const store = createStore(Immutable.fromJS(dehydratedState));
		const RouterWithContext = provideContext(
			Router,
			{
				store:PropTypes.object
			}
		); // ToDo: get FluxibleComponent to work...
		render(<RouterWithContext history={history} context={{store:store}}>{app.getRoutes()}</RouterWithContext>, document.getElementById(app.getId()));

		store.dispatch(initializeClient());
		// window.Perf = React.addons.Perf;
		// React.addons.Perf.start();
		window.Store = store;
		debug('React Rendered');
} catch (err) {
	if(window.console && window.console.log) {
		window.console.log(err);
		window.console.log(err.stack);
	}
	error(err.message, err.stack);
}



/** WEBPACK FOOTER **
 ** ./client/index.js
 **/